// if (!customElements.get('newsletter-modal')) {
//   customElements.define(
//     'newsletter-modal',
//     class NewsletterModal extends ModalElement {
//       constructor() {
//         super();
    
//         // Prevent popup on Shopify robot challenge page
//         if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
//           return;
//         }
    
//         if (!theme.config.isTouch || Shopify.designMode) {
//           this.init();
//         }
//         else {
//           new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
//         }
//       }
    
//       get shouldLock() {
//         return true;
//       }
    
//       get testMode() {
//         return this.getAttribute('data-test-mode') === 'true';
//       }
    
//       get delay() {
//         return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
//       }
    
//       get expiry() {
//         return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
//       }
    
//       get cookieName() {
//         return 'concept:newsletter-popup';
//       }
    
//       get submited() {
//         return this.querySelector('.alert') !== null;
//       }
    
//       init() {
//         if (this.initialized) return;
//         this.initialized = true;
        
//         // Open modal if errors or success message exist
//         if (this.submited) {
//           this.load(1);
//           return;
//         }
    
//         if (this.testMode || !this.getCookie(this.cookieName)) {
//           this.load(this.delay);
//         }
//       }
    
//       load(delay) {
//         if (Shopify.designMode) return;
    
//         setTimeout(() => this.show(), delay * 1000);
//       }
    
//       afterShow() {
//         super.afterShow();
//         this.classList.add('show-image');
//       }
    
//       afterHide() {
//         super.afterHide();
//         this.classList.remove('show-image');
    
//         // Remove a cookie in case it was set in test mode
//         if (this.testMode) {
//           this.removeCookie(this.cookieName);
//           return;
//         }
    
//         this.setCookie(this.cookieName, this.expiry);
//       }
    
//       getCookie(name) {
//         const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
//         return match ? match[2] : null;
//       }
    
//       setCookie(name, expiry) {
//         document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
//       }
    
//       removeCookie(name) {
//         document.cookie = `${name}=; max-age=0`;
//       }
//     }
//   );
// }



if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:newsletter-popup';
      }
    
      get submited() {
        return this.querySelector('.alert') !== null;
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;

        // Theme-editor preview of the success state. Design mode only, opt-in via the
        // "Preview success state in editor" setting (data-preview-success on the modal).
        if (this.dataset.previewSuccess === 'true' && Shopify.designMode) {
          setTimeout(() => {
            this.showSuccessState(false);
            this.show();
          }, 500);
        }

        // Open modal if errors or success message exist
        if (this.submited) {
          this.load(1);
          return;
        }

        // Auto-open gating: the section renders everywhere (for the sticky tab), but only
        // auto-opens where data-auto-open="true" (homepage + logged-out, per section settings)
        if (this.getAttribute('data-auto-open') !== 'true') return;

        // Suppression: visitor has already subscribed
        if (this.readFlag()) return;

        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
      }

      // Where focus lands on open (overrides ModalElement.focusElement, theme.js is not edited)
      get focusElement() {
        // Success state: the success message, so it is read out and focus stays inside the dialog
        if (this.getAttribute('data-state') === 'success') {
          const heading = this.querySelector('.newsletter-success-heading');
          if (heading) {
            heading.setAttribute('tabindex', '-1');
            return heading;
          }
        }

        // User-initiated open (tab click): activeElement is the trigger -> email field.
        // Auto-open: activeElement is null -> keep the default target, so no on-screen keyboard on touch.
        const input = this.activeElement && this.querySelector('input[type="email"]');
        return input || super.focusElement;
      }

      beforeShow() {
        super.beforeShow();

        // Remember what had focus, so it can be restored on close (auto-open passes no trigger)
        this._savedFocus = document.activeElement;

        // Subscribed visitor: open straight into the success state. Skipped when it is already
        // set (a just-submitted visitor: newsletter-signup.js applied the fresh-signup text).
        if (this.readFlag() && this.getAttribute('data-state') !== 'success') {
          this.showSuccessState(true);
        }
      }

      // Same logic as newsletter-signup.js. Kept separate on purpose: this file is loaded first and
      // runs init() as soon as the element is defined, before newsletter-signup.js exists.
      readFlag() {
        const key = 'eivoge_newsletter_subscribed';
        try {
          if (localStorage.getItem(key)) return true;
        } catch (e) {}
        try {
          return document.cookie.split(';').some((c) => c.trim().indexOf(key + '=') === 0);
        } catch (e) {}
        return false;
      }

      // Switch the form(s) in this modal to the success state. returning=true uses the
      // "returning visitor" text, false the fresh-signup text.
      showSuccessState(returning) {
        const wrappers = this.querySelectorAll('newsletter-signup');
        if (!wrappers.length) return;

        const api = window.eivogeNewsletter;
        wrappers.forEach((wrapper) => {
          if (api && api.showSuccess) {
            api.showSuccess(wrapper, { returning });
            return;
          }
          // Fallback if newsletter-signup.js has not loaded: state + visibility only
          wrapper.setAttribute('data-state', 'success');
          const successEl = wrapper.querySelector('.newsletter-success');
          if (successEl) successEl.removeAttribute('hidden');
        });

        this.setAttribute('data-state', 'success');
      }

      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');

        // Auto-open has no trigger element, so the base class has nothing to restore focus to.
        // Return it to whatever had it before the popup opened.
        const savedFocus = this._savedFocus;
        this._savedFocus = null;
        if (!this.activeElement && savedFocus && savedFocus !== document.body && document.contains(savedFocus)) {
          setTimeout(() => savedFocus.focus(), 50);
        }

        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}